var $2bea12bc13111737$exports = {};
$2bea12bc13111737$exports = {
  "alert": "Alerta",
  "dismiss": "Dispensar"
};
export { $2bea12bc13111737$exports as default };